module.exports = __webpack_public_path__ + "static/media/cert_12485.f0b0fa8b.jpg";